// very basic static cache storage for the game

import { deepClone } from "./object";

export enum CacheKeys {
	FirstFGResumeResponse = "firstFGResumeResponse",
	FirstFGSpinResponse = "firstFGSpinResponse",
}

export class CacheStorage {
	private static cache: Record<string, unknown> = {};

	public static set(key: CacheKeys, value?: unknown): void {
		if (value === undefined) {
			delete this.cache[key];
			return;
		}

		this.cache[key] = deepClone(value);
	}

	public static get<T>(key: CacheKeys): T {
		return this.cache[key] as T;
	}
}
